export const IS_DEVELOPMENT = process.env.MODE === 'development';
export const IS_DEVELOPMENT_OR_STAGING =
  process.env.MODE === 'development' || process.env.MODE === 'staging';
export enum COOKIE_KEYS {
  AC_TOKEN = 'ac-auth.id-token',
  AC_REFRESH_TOKEN = 'ac-auth.refresh-token',
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
  LEGACY_TOKEN = 'legacy_token',
}

export enum SAME_SITE_TYPE {
  STRICT = 'Strict',
  LAX = 'Lax',
  NONE = 'none',
}
